<template>
<div>
<el-card class="main-body-card">
  <div slot="header" class="card-div-header">
    <span v-if="cardTitle" class="span-title">{{ cardTitle }}</span>
    <el-input v-model="pager.fuzzyText" size="small" style="width: 250px; margin-right: 10px"
      :placeholder="$t('c.search.placeholder')" @keyup.enter.native="searchMain(1)">
      <el-button slot="append" icon="el-icon-search" @click="searchMain(1)"></el-button>
    </el-input>
    <el-button v-show="actionValueAsComp < 3" size="small" type="primary" icon="el-icon-plus" @click="openDialog(ACTION.NEW)">{{ $t('c.table.new') }}</el-button>
    <el-button v-show="actionValueAsComp < 3" size="small" type="danger" icon="el-icon-delete" @click="deleteBatch()">{{ $t('c.table.delete') }}</el-button>
  </div>
  <el-main class="main-body-table">
    <el-table :data="mainTableData" @sort-change="sortChange" @row-dblclick="rowDblclick" @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="30">
      </el-table-column>
      <el-table-column
        prop="originator"
        :label="$t('c.notice.originator')"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="title"
        :label="$t('c.notice.title')"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="message"
        :label="$t('c.notice.message')"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="orgFullName"
        :label="$t('c.notice.receivers')"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="startDate"
        :label="$t('c.notice.startDate')"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="endDate"
        :label="$t('c.notice.endDate')"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="confirmReceived"
        :label="$t('c.notice.confirmReceived')"
        align="center"
        sortable="custom">
      </el-table-column>
      <!-- <el-table-column
        prop="extra"
        :label="$t('c.notice.extra')"
        align="center"
        sortable="custom">
      </el-table-column> -->
      <el-table-column
        prop="statusDictValue"
        :label="$t('c.notice.status')"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column v-if="actionValueAsComp < 3" :label="$t('c.table.operation')" width="95" align="center">
        <template slot-scope="scope">
          <i class="el-icon-view icon-button" :title="$t('c.table.view')" @click="openDialog(ACTION.VIEW, scope.row, scope.$index)"></i>
          <i class="el-icon-edit icon-button" :title="$t('c.table.edit')" @click="openDialog(ACTION.EDIT, scope.row, scope.$index)"></i>
          <i class="el-icon-delete icon-button" :title="$t('c.table.delete')" @click="deleteRow(scope.row, scope.$index)"></i>
        </template>
      </el-table-column>
    </el-table>
    <!--分页工具条-->
    <el-pagination class="main-body-table-page" layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"
      :current-page="pager.current" :page-size="pager.size" :total="total">
    </el-pagination>
  </el-main>
  <comp-notice v-if="detailDialogVisible"
    :actionOfParent="currentAction"
    :currentTableRow="currentTableRow"
    :detailDialogVisible.sync="detailDialogVisible"
    @listenToDetailDialogClose="detailDialogCloseWithModified"
    :receiversOptions="receiversOptions"
    :statusDicts="statusDicts"
  >
  </comp-notice>
</el-card>
</div>
</template>

<script>
import {
  selectPageByFuzzyNotice,
  deleteByIdNotice,
  deleteBatchIdsNotice
} from '../../api/sys/Notice';

import CompNotice from '../../comp/sys/CompNotice';
import { selectListOrg,selectBriefEdition } from '../../api/sum/Org'
export default {
  name: 'sysNotice',
  props: {
    // 外键约束属性
    extra: String,
    // 来自父组件指定的标题
    cardTitle: String,
    // 来自父组件的操作类型参数
    actionOfParent: Object
  },
  components: {
    CompNotice
  },
  data() {
    return {
      // 主表记录总数
      total: 0,
      // 分页及查询对象
      pager: {
        current: 1,
        size: 10,
        fuzzyText: ''
      },
      // 当前操作类型, ACTION.NEW/ACTION.EDIT/ACTION.VIEW
      currentAction: {},
      // 当前主表行记录
      currentTableRow: {},
      // 当前主表中选中的行记录
      selectedRows: [],
      // 主表数据
      mainTableData: [],
      // 作为组件时的操作类型, 根据父组件变动, 默认为2:编辑
      actionValueAsComp: 2,
      // 是否已经有服务端更新
      modified: false,
      // 外键数据列表: 接收方
      receiversOptions: [],
      // 对话框显示隐藏控制
      detailDialogVisible: false
    };
  },
  computed: {
    // 字典数据列表: 通知状态, 放在computed中确保i18n可用
    statusDicts: function () {
      return [ { itemCode: 'normal', value: this.$t('c.notice.normal') }, { itemCode: 'overdue', value: this.$t('c.notice.overdue') } ];
    },
    // 操作类型常量
    ACTION: function () {
      return {
        NEW: { value: 1, name: this.$t('c.table.new') },
        EDIT: { value: 2, name: this.$t('c.table.edit') },
        VIEW: { value: 3, name: this.$t('c.table.view') }
      }
    }
  },
  // 页面首次加载数据
  mounted() {
    if (this.actionOfParent) {
      this.actionValueAsComp = this.actionOfParent.value;
    }
    this.searchMain(1);
  },
  methods: {
    /**
     * 点击列标题排序
     * @param column 点击排序的列对象
     */
    sortChange: function(column) {
      this.pager.prop = column.prop;
      this.pager.order = column.order;
      if (column.prop === 'statusDictValue') {
        this.pager.prop = 'status';
      }
      this.searchMain(1);
    },
    /**
     * 主表勾选记录事件
     * @param {Array} rows 当前选中的记录列表
     */
    handleSelectionChange: function(rows) {
      this.selectedRows = rows;
    },
    /**
     * 更新成功后的关闭对话框事件
     * @param {ACTION} action 操作类型
     */
    detailDialogCloseWithModified: function(action) {
      if (action.value === 1) {
        // NEW
        this.searchMain(1);
      } else if (action.value === 2) {
        // EDIT
        this.searchMain();
      }
      this.$emit('listenToCompModifiedEvent')
    },
    /**
     * 主表每页记录数调整后的查询
     * @param size int 调整后的每页记录数
     */
    handleSizeChange(size) {
      this.pager.size = size;
      this.searchMain();
    },
    /**
     * 主表翻页查询
     * @param current int 指定查询页号
     */
    handleCurrentChange(current) {
      this.pager.current = current;
      this.searchMain();
    },
    /**
     * 分页模糊查询
     * @param current int 可选参数，查询指定页的数据
     * current: 不传值或传null/undefined/0，表示翻页
     * current: 大于等于1表示重新查询该页
     *    例如：更新某记录后重新加载当前页
     *    例如：删除某记录、查询文本框回车、查询按钮点击则传1，重新查询第1页
     */
    searchMain(current) {
      this.pager.extra = this.extra;
      if (current && current >= 1) {
        // 重新查询该页
        this.pager.current = current;
      }
      this.fetchMainTable();
    },
    /**
     * 模糊查询主表数据
     */
    fetchMainTable() {
      selectPageByFuzzyNotice(this.pager).then(result => {
        let { data } = result;
        this.total = data.total;
        this.mainTableData = data.records;
        this.setDictValueColumn();
      });
    },
    /**
     * 设置主表数据集合中字典itemCode列的字典值列
     */
    setDictValueColumn() {
      if (this.mainTableData && this.mainTableData.length > 0) {
        this.mainTableData.forEach(row => {
          row.statusDictValue = this.findDictItemValueByItemCode(
            row.status,
            this.statusDicts
          );
        });
        // 使数组的更新被VUE检测到
        this.mainTableData.push({});
        this.mainTableData.pop();
      }
    },
    /**
     * 有唯一索引的属性是否被修改过
     * @returns boolean true表示修改过 false表示未被修改
     */
    isModifiedOfUnique() {
      let modified = false;
      this.mainTableData.some(item => {
        if (item.id === this.formModel.id) {
          modified = item.title !== this.formModel.title;
          return true;
        }
      });
      return modified;
    },
    /**
     * 删除该行记录
     * @param row 行记录对象
     * @param index 行索引号
     */
    deleteRow(row, index) {
      this.$confirm(this.$t('c.table.deleteRowConfirm'), this.$t('c.tips'), {
        type: 'warning'
      })
        .then(() => {
          deleteByIdNotice({ id: row.id }).then(result => {
            this.$emit('listenToCompModifiedEvent')
            this.searchMain(1);
          });
        })
        .catch(() => {});
    },
    /**
     * 批量删除记录
     */
    deleteBatch() {
      if (this.selectedRows.length === 0) {
        this.$message({
          type: 'info',
          message: this.$t('c.table.pleaseSelectForDelete')
        });
        return;
      }
      this.$confirm(
        this.$t('c.table.deleteBatchConfirm1') + this.selectedRows.length + this.$t('c.table.deleteBatchConfirm2'),
        this.$t('c.tips'),
        { type: 'warning' }
      )
        .then(() => {
          deleteBatchIdsNotice({ lsIds: this.selectedRows.map(row => row.id) }).then(result => {
            this.$emit('listenToCompModifiedEvent')
            this.searchMain(1);
          });
        })
        .catch(() => {});
    },
    /**
     * 表格行双击事件打开查看对话框
     * @param row 双击的行记录对象
     * @param event 鼠标事件
     * @param column 双击的列对象
     */
    rowDblclick(row, event, column) {
      this.openDialog(this.ACTION.VIEW, row)
    },
    /**
     * 打开对话框
     * @param action ACTION.NEW/ACTION.EDIT/ACTION.VIEW
     * @param row 行记录对象，新增时为空
     * @param indexOfRow 行索引号，新增时为空
     */
    openDialog(action, row, indexOfRow) {
      this.currentTableRow = Object.assign({}, row || this.getDefaultFormModel());
      this.currentAction = action;
      if (this.receiversOptions && this.receiversOptions.length > 0) {
        // 已经加载外键列表数据，可以直接弹出对话框
        this.detailDialogVisible = true;
        return;
      }
      // selectListOrg({}).then(result => {
      //   this.receiversOptions = result.data;
      //   this.detailDialogVisible = true;
      // });
      selectBriefEdition().then(result => {
        if(result.code == 20000 && result.data) {
          this.receiversOptions = result.data;
          this.detailDialogVisible = true;
        }
      })
    },
    /**
     * 根据itemCode从字典项列表dicts查找对应记录的value并返回
     * @param itemCode 字典项编码，多个以逗号分隔
     * @param dicts 字典项列表
     * @returns 字典value，多个以逗号分隔
     */
    findDictItemValueByItemCode(itemCode, dicts) {
      if (!itemCode) {
        return '';
      }
      let codes = itemCode.split(',');
      let items = dicts.filter(item => {
        return codes.some(code => {
          return code === item.itemCode;
        });
      });
      return items.map(item => item.value).join(';');
    },
    /**
     * 设置新增对话框表单中的默认值
     * @returns 默认值对象
     */
    getDefaultFormModel() {
      return {
        // postId: this.postIdDicts[0].itemCode,
        // orgId: this.orgIdOptions[0].id
        extra: this.extra,
        status: 'normal'
      };
    }
  }
};
</script>

<style lang="scss">
</style>
